import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { Transition } from '@headlessui/react';
import { RemoveScroll } from 'react-remove-scroll';
import classNames from 'classnames';
import Div100vh from 'react-div-100vh';
import useOnEsc from 'hooks/useOnEsc';
import useTrapFocus from 'hooks/useTrapFocus';
import useRandomId from 'hooks/useRandomId';
import getOrCreateElementById from 'commons/getOrCreateElementById';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import useFocusOnOpen from 'hooks/useFocusOnOpen';
import MobileNavbarHiddenCloseButton from 'components/nav/MobileNavbarModal/components/MobileNavbarHiddenCloseButton';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
const MobileSlideOutModalRootElement = getOrCreateElementById('MobileSlideOutModal-root');
const MobileSlideOutModal = t0 => {
  const $ = _c(37);
  const {
    children,
    footer,
    header,
    isOpen: t1,
    noPadding: t2,
    onClose,
    title
  } = t0;
  const isOpen = t1 === undefined ? false : t1;
  const noPadding = t2 === undefined ? false : t2;
  const modalRef = useFocusOnOpen(isOpen);
  const modalTitleId = useRandomId("MobileSlideOutModal-title");
  useOnEsc(isOpen, onClose);
  useTrapFocus(isOpen, modalRef);
  let t3;
  if ($[0] !== onClose) {
    t3 = <Transition.Child aria-hidden={true} className="fixed bottom-0 top-0 left-0 right-0 [background:rgba(0,0,0,.6)] hover:cursor-pointer" onClick={onClose} tabIndex="-1" enter="transition-[opacity,transform] ease-in-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-[opacity,transform] ease-in-out duration-300" leaveFrom="opacity-100" leaveTo="opacity-0" />;
    $[0] = onClose;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = !noPadding;
  const t5 = !!footer;
  const t6 = !!header;
  const t7 = !!noPadding;
  let t8;
  if ($[2] !== t4 || $[3] !== t5 || $[4] !== t6 || $[5] !== t7) {
    t8 = classNames("h-full overflow-x-hidden overflow-y-auto w-[80vw]", {
      "p-4": t4,
      "pb-0": t5,
      "pt-0": t6,
      "p-0": t7
    });
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <VisuallyHidden>Dialog content starts</VisuallyHidden>;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== onClose) {
    t10 = <div className="items-center flex justify-end p-2 pointer-events-none fixed right-0 top-0 w-[20vw]"><MobileNavbarHiddenCloseButton onClick={onClose} /></div>;
    $[8] = onClose;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== header) {
    t11 = !!header && <div className="bg-gray-light9 pb-3 pt-3 mb-3 sticky top-0 z-[1] after:[border-bottom:1px_solid_#f1f1f1] after:[content:''] after:-left-4 after:absolute after:-right-4 after:bottom-0">{header}</div>;
    $[10] = header;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== title) {
    t12 = !!title && <div className="text-xl font-bold text-gray m-0 pt-0 px-0 pb-2">{title}</div>;
    $[12] = title;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== children) {
    t13 = <div className="flex-1">{children}</div>;
    $[14] = children;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== footer) {
    t14 = !!footer && <div className="bg-gray-light9 bottom-0 mt-3 pb-3 pt-3 sticky z-[1] before:[border-top:1px_solid_#f1f1f1] before:[content:''] before:-left-4 before:absolute before:-right-4 before:top-0">{footer}</div>;
    $[16] = footer;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <VisuallyHidden>Dialog content ends</VisuallyHidden>;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== modalRef || $[20] !== modalTitleId || $[21] !== t10 || $[22] !== t11 || $[23] !== t12 || $[24] !== t13 || $[25] !== t14) {
    t16 = <Div100vh ref={modalRef} role="dialog" aria-labelledby={modalTitleId} className="flex flex-col">{t9}{t10}{t11}{t12}{t13}{t14}{t15}</Div100vh>;
    $[19] = modalRef;
    $[20] = modalTitleId;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== isOpen || $[28] !== t16 || $[29] !== t8) {
    t17 = <Transition.Child className="bg-gray-light9 cursor-default h-full fixed left-0 top-0" enter="transition-[opacity,transform] ease-in-out duration-300" enterFrom="opacity-0 translate-x-[-100vw]" enterTo="opacity-100 translate-x-0" leave="transition-[opacity,transform] ease-in-out duration-300" leaveFrom="opacity-100 translate-x-0" leaveTo="opacity-0 translate-x-[-120vw]"><RemoveScroll className={t8} removeScrollBar={false} enabled={isOpen}>{t16}</RemoveScroll></Transition.Child>;
    $[27] = isOpen;
    $[28] = t16;
    $[29] = t8;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t17 || $[32] !== t3) {
    t18 = <div>{t3}{t17}</div>;
    $[31] = t17;
    $[32] = t3;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== isOpen || $[35] !== t18) {
    t19 = createPortal(<Transition show={isOpen}>{t18}</Transition>, MobileSlideOutModalRootElement);
    $[34] = isOpen;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  return t19;
};
MobileSlideOutModal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  noPadding: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node,
  footer: PropTypes.node,
  header: PropTypes.node
};
export default withBrowserOnly(MobileSlideOutModal);